import { Component, OnInit, ViewChild, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { ShoppingCartService } from 'lms-api';
import { ShoppingCartItem } from 'lms-api';
import { LMSDataService } from 'lms-api';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CheckoutComponent } from '../checkout/checkout.component';
import { UserCourseDataService } from 'lms-api';
import { LoginComponent } from '../login/login.component';
import { LmsUserService } from 'lms-api';

@Component({
  selector: 'app-shopping-cart-display',
  templateUrl: './shopping-cart-display.component.html',
  styleUrls: ['./shopping-cart-display.component.scss']
})
export class ShoppingCartDisplayComponent implements OnInit {
  @ViewChild('promocode') promoCodeInput: ElementRef;
  public promoCode: string = '';

  public cartCourses: ShoppingCartItem[];
  public cartSubscriptions: ShoppingCartItem[];
  public CartDetails$ = this.cartService.CartDetails;
  public ItemArray: ShoppingCartItem[] = [];

  constructor(public cartService: ShoppingCartService, public lmsDataService: LMSDataService, public modalService: NgbModal, public ucdService: UserCourseDataService, public lmsUserService: LmsUserService) {
    combineLatest(cartService.CartDetails, lmsDataService.OnCoursesUpdated, lmsDataService.OnBundlesUpdated).pipe(
      map(([cartDetails, courses, bundles]) => {
        this.cartCourses = [];
        cartDetails.Courses.forEach(cartItem => {
          cartItem.SetItem(courses.find(course => course.netforum_course_id == cartItem.ItemID));
          this.cartCourses.push(cartItem);
        });
        this.cartSubscriptions = [];
        cartDetails.Subscriptions.forEach(cartItem => {
          cartItem.SetItem(bundles.find(bundle => bundle.product_code == cartItem.ItemID));
          this.cartSubscriptions.push(cartItem);
        });
        this.ItemArray = cartDetails.ItemArray.filter(i => i.Item);
      })
    ).subscribe();
  }

  ngOnInit() { }

  ShowLogin() {
    this.modalService.open(LoginComponent);
  }

  UpdatePromoCode() {
    this.promoCode = this.promoCodeInput.nativeElement.value;
  }

  ApplyPromoCode() {
    this.cartService.SetPromoCode(this.promoCode).subscribe();
  }

  RemoveItem(itemType: 'Course' | 'Subscription', itemId: string) {
    switch (itemType) {
      case 'Course':
        this.cartService.RemoveCourse(itemId).subscribe();
        break;
      case 'Subscription':
        this.cartService.RemoveBundle(itemId).subscribe();
        break;
    }

  }

  ShowCheckout() {
    this.modalService.open(CheckoutComponent);
  }

  OpenJoinWindow() {
    window.open("https://www.abmp.com/signup?destination=learn");
  }

}
